/* eslint-disable */
import React, { useEffect, useState, useRef, useContext } from "react";
import Card from "../../components/card.component";
import { Row, Col, Pagination } from "react-bootstrap";
import { useForm } from "react-hook-form";
import DataTable from "react-data-table-component";
import general from "../../general/general.functions";
import moment from "moment";
import notification from "../../components/notification.component";
import pad from "pad";
import paquetesFunction from "./paquetes.functions";
import tablePaquetes from "./paquetes.table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "../../components/modal/modal.component";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { faSearch, faPlus, faCheck } from "@fortawesome/free-solid-svg-icons";
import utils from "../../utils/utils.functions";
import PagoGuia from "../../components/pago.component";
import SegurosGuia from "../../components/seguros.component";
import { ConfigContext } from "../../context/config.context";
import numeral from "numeral";
import DestinatariosModal from "../../components/destinatario.component";
import DireccionesModal from "../../components/direcciones.component";
import ConfirmAlertV2 from "../../components/confirmv2.component";
import DataTableExtensions from "react-data-table-component-extensions";
import FacturacionComponent from "../facturacion/facturacion.component";
import { ConfigContextUtils } from "../../context/contextUtils.context";
import BultosModalGuia from "../../components/bultos-modal-guia/BultosModalGuia";
import { useDebounceValue } from '../../components/debounceSearch.component';

let modEspera = false;

const Paquetes = () => {
  const inititalBultos = {
    alto: 0,
    ancho: 0,
    largo: 0,
    peso: 0,
    pies: 0,
    uuid: null,
  };
  const { config } = useContext(ConfigContext);
  const { setPreloader } = useContext(ConfigContextUtils);
  const search = useRef();
  const inputBultosRef = useRef([]);
  const history = useHistory();
  const [modalShow, setModalShow] = useState(false);
  const [tipos, setTipos] = useState([]);
  const [master, setMaster] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [detalles, setDetalles] = useState(false);
  const [productos, setProductos] = useState([]);
  const [bultos, setBultos] = useState([]);
  const [procesando, setProcesando] = useState(false);
  const [clientesFull, setClienteFull] = useState([]);
  const [bultosDatos, setBultosDatos] = useState(inititalBultos);
  const [editBultos, setEditoBultos] = useState(false);
  const [productosWait, setProductosWait] = useState({
    cantidad: "",
    descripcion_productos: "",
    uuid: null,
  });
  const [modalPago, setModalPago] = useState(false);
  const [estadosp, setEstadosp] = useState([]);
  const [ciudadp, setCiudadp] = useState([]);
  const [paisesp, setPaisesp] = useState([]);
  const [totalMonto, setTotalMonto] = useState(0);
  const [multiselect, setMultiSelect] = useState(false);
  const [guideFullInformation, setGuideFullInformation] = useState(null);
  const { register, handleSubmit, errors, setValue, getValues, reset } =
    useForm();
  const [editableInputsRecipients, setInputsRecipients] = useState({
    address: false,
    recipent: false,
    addressId: null,
    recipientId: null,
  });

  const resetClientParams = {
    pagination: 1,
    isLastPage: false,
    lastPage: 0,
  }
  const [reserveMode, setReserveMode] = useState(false);
  const [modalBultos, setModalBultos] = useState(false);
  const [dataModalBultos, setDataModalBultos] = useState(null);
  const [pagination, setPagination] = useState(resetClientParams);
  const [findText, setFindText] = useState('');
  const [filtros, setFiltros] = useState(null);

  const deboncedValue = useDebounceValue(findText, 1500);

  useEffect(() => {
    if (deboncedValue.trim() !== '') {
      listadoClientes({
        pagination: 1,
        findText,
      });
    } else {
      listadoClientes({
        pagination: 1,
      });
      setFiltros(null);
    }
 }, [deboncedValue])

  useEffect(() => {
    if (Object.keys(errors).length) {
      notification.warning(
        "Faltan datos por completar en la guia, verifique toda la información"
      );
      modEspera = false;
    }
  }, [errors]);

  const estadosLista = () => {
    general.estados().then((respuesta) => {
      setEstadosp(respuesta.estados);
    });
  };

  const paisesLista = () => {
    general.paises().then((respuesta) => {
      setPaisesp(respuesta.response);
    });
  };

  useEffect(() => {
    modEspera = false;
  }, []);

  const calculateTotalMonto = () => {
    let total = 0;
    if (pagos.length) {
      pagos.forEach((element) => {
        total += parseInt(element.monto);
      });
    }
    setTotalMonto(total);
  };

  const selectPais = (event) => {
    const id = event.target.value;
    if (id !== "null") {
      const index = paisesp.findIndex((val) => val.id === parseInt(id));
      const values = paisesp[index];
      setMultiSelect(values.multiselect);
      if (!values.multiselect) {
        setValue("estado", 26);
        setValue("ciudad", 523);
      }
    } else {
      setMultiSelect(false);
    }
  };

  const selectedEstado = (element) => {
    if (element.target.value === "null") {
      setCiudadp([]);
    } else {
      general.ciudades({ estado: element.target.value }).then((respuesta) => {
        setCiudadp(respuesta.ciudad);
      });
    }
  };

  const onSubmit = (data) => {
    const detalleIsPassed = validarDetalle();
    let consolidationDetalle = null;
    let consolidationBultos = null;
    let passed = true;

    if (detalleIsPassed.status && detalleIsPassed.products) {
      consolidationDetalle = { detalle_productos_guias: productos };
    } else if (!detalleIsPassed.status) {
      notification.warning(
        "La opción del detalle esta activa, debe agregar al menos un producto"
      );
      passed = false;
    } else if (detalleIsPassed.status && !detalleIsPassed.products) {
      consolidationDetalle = { detalle_productos_guias: null };
    }

    const bultosIsPassed = validarBultos();

    if (bultosIsPassed.status) {
      consolidationBultos = { bultos_detalle: bultos };
    } else {
      consolidationBultos = { bultos_detalle: null };
      notification.warning("Debe agregar (1) bulto por lo menos");
      passed = false;
    }

    if (passed) {
      const alldata = {
        ...data,
        ...consolidationBultos,
        ...consolidationDetalle,
        pagos: [],
        seguros: [],
        modEspera,
        prefijo: config.prefijo_correlativo_guia,
        is_guide: true,
        complete_payment: false,
        recipient: {
          ...editableInputsRecipients,
        },
      };

      modalPagoInit();
      setGuideFullInformation(alldata);

      /*
      setPreloader(true);
      setProcesando(true);

      paquetesFunction.registrarGuia({ data_full_guide: alldata }).then((response) => {
        if (response.status === 200) {
          if (response.data.registro_guia) {
            setGuideFullInformation(null);
            history.replace(`/detalle/${response.data.uuid}`);
          } else {
            notification.warning('Revise la información existe un problema con los datos');
          }
          setProcesando(false);
          setPreloader(false);
        }
      })*/
    } else {
      modEspera = false;
    }
  };

  useEffect(() => {
    if (modalShow) {
      setClientes(clientesFull);
    }
  }, [modalShow]);

  const listaTipo = () => {
    general.tiposSalidas().then((tipos) => {
      setTipos(tipos);
    });
  };

  const masterList = (e) => {
    if (e.target.value !== "null") {
      paquetesFunction
        .withMaster({ type: parseInt(e.target.value) })
        .then((response) => {
          setMaster(response);
        });
    } else {
      setMaster([]);
    }
  };

  useEffect(() => {
    general.listadoClientesV2({ pagination: 1 }).then((response) => {
      setClientes(response.client);
      setClienteFull(response.client);
    });
    listaTipo();
    estadosLista();
    paisesLista();
  }, []);

  const seleccionarClienteModal = (row) => {
    if (clienteSeleccionado !== null) {
      if (row.id !== clienteSeleccionado.id) {
        if (editableInputsRecipients.recipent) {
          cleardestinatario();
        }
        if (editableInputsRecipients.address) {
          limpiardireccion();
        }
      }
    }

    setClienteSeleccionado(row);
    setModalShow(false);
  };

  const setValuesProductos = (element) => {
    setProductosWait({
      ...productosWait,
      [element.target.name]: element.target.value,
      uuid: uuidv4(),
    });
  };

  const removeProducto = (row) => {
    const index = productos.findIndex((e) => e.uuid === row.uuid);
    const updateElement = [...productos];
    updateElement.splice(index, 1);
    setProductos(updateElement);
  };

  const removeBultos = (row) => {
    const index = bultos.findIndex((e) => e.uuid === row.uuid);
    const updateElement = [...bultos];
    updateElement.splice(index, 1);
    setBultos(updateElement);
  };

  const agregarProductos = () => {
    if (
      productosWait.cantidad !== "" &&
      productosWait.descripcion_productos.trim() !== ""
    ) {
      setProductos([{ ...productosWait }, ...productos]);
      setProductosWait({ cantidad: "", descripcion_productos: "", uuid: null });
    } else {
      notification.warning(
        "Debe completar los campos para agregar un producto"
      );
    }
  };

  const setValuesBultos = (element) => {
    setBultosDatos({
      ...bultosDatos,
      [element.target.name]: element.target.value,
    });
  };

  const agregarBultos = () => {
    if (
      bultosDatos.alto !== "" &&
      bultosDatos.ancho !== "" &&
      bultosDatos.largo !== "" &&
      bultosDatos.peso !== "" &&
      bultosDatos.peso > 0
    ) {
      setBultos([
        {
          alto: numeral(bultosDatos.alto).format("0.00"),
          ancho: numeral(bultosDatos.ancho).format("0.00"),
          largo: numeral(bultosDatos.largo).format("0.00"),
          peso: numeral(bultosDatos.peso).format("0.00"),
          pie: calculatePieCubico(),
          uuid: uuidv4(),
          guia_externa: "",
        },
        ...bultos,
      ]);
      setBultosDatos(inititalBultos);
    } else {
      notification.warning("Complete la información para agregar un bulto");
    }
  };

  const calculatePieCubico = () => {
    let piesCubico = utils.calculatePiesCubicos(
      bultosDatos.alto,
      bultosDatos.ancho,
      bultosDatos.largo,
      config.formula_pies_cubicos
    );
    return piesCubico;
  };

  const validarDetalle = () => {
    if (detalles) {
      if (!productos.length) {
        return { status: false };
      } else {
        return { status: true, products: true };
      }
    } else {
      return { status: true, products: false };
    }
  };

  const validarBultos = () => {
    if (!bultos.length) {
      return { status: false };
    } else {
      return { status: true };
    }
  };

  const buscador = (element) => {
    const resultado = utils.filterTable(clientesFull, element.target.value);
    setClientes(resultado);
  };

  const modalPagoInit = (fromInvoice) => {
    setModalPago(!modalPago);
    if (fromInvoice) {
      setReserveMode(false);
    }
  };

  const destinatarioSelected = (destina) => {
    const allValues = getValues();
    reset({
      ...allValues,
      cliente_nombre_receptor: destina.cliente_receptor_nombre,
      cliente_telefono_receptor: destina.cliente_receptor_telefono,
      cliente_identificacion_receptor: destina.cliente_receptor_identificacion,
    });

    setInputsRecipients({
      ...editableInputsRecipients,
      recipent: true,
      recipientId: destina.id,
    });
  };

  const cleardestinatario = () => {
    const allValues = getValues();
    reset({
      ...allValues,
      cliente_nombre_receptor: "",
      cliente_telefono_receptor: "",
      cliente_identificacion_receptor: "",
    });

    setInputsRecipients({
      ...editableInputsRecipients,
      recipent: false,
      recipientId: null,
    });
  };

  const editarBultos = (row) => {
    setBultosDatos(row);
    setEditoBultos(true);
  };

  const calcelareditBultos = () => {
    setBultosDatos(inititalBultos);
    setEditoBultos(false);
  };

  const confirmareditBultos = () => {
    const indexBulto = bultos.findIndex((val) => val.uuid === bultosDatos.uuid);
    const clonBultos = [...bultos];
    clonBultos[indexBulto] = { ...bultosDatos, pie: calculatePieCubico() };
    setBultos(clonBultos);
    calcelareditBultos();
  };

  const confirmModoEspera = () => {
    modEspera = true;
    setReserveMode(true);
    handleSubmit(onSubmit)();
  };

  const direccionSelecionada = (direccion) => {
    setValue(
      "cliente_direccion_entrega",
      direccion.cliente_receptor_direccion_entrega
    );
    setValue("pais", direccion.recipient_pais.id);
    setMultiSelect(direccion.recipient_pais.multiselect);
    if (direccion.recipient_pais.multiselect) {
      general
        .ciudades({ estado: direccion.recipient_estado.id })
        .then((respuesta) => {
          setCiudadp(respuesta.ciudad);
          setTimeout(() => {
            setValue(
              "estado",
              direccion.recipient_pais.multiselect
                ? direccion.recipient_estado.id
                : 26
            );
            setValue("ciudad", direccion.recipient_ciudad.id_ciudad);
          }, 400);
        });
    } else {
      setValue("ciudad", 523);
    }

    setInputsRecipients({
      ...editableInputsRecipients,
      address: true,
      addressId: direccion.id,
    });
  };

  const limpiardireccion = () => {
    setValue("cliente_direccion_entrega", "");
    setValue("estado", "null");
    setValue("ciudad", "null");
    setValue("pais", "null");
    setInputsRecipients({
      ...editableInputsRecipients,
      address: false,
      addressId: null,
    });
  };

  const callbackBultos = (value) => {
    const cloneBulto = [...bultos];
    const findIndex = cloneBulto.findIndex(
      (item) => item.uuid === dataModalBultos.uuid
    );
    cloneBulto[findIndex].guia_externa = value.toUpperCase().trim();
    setBultos(cloneBulto);
    setModalBultos(false);
    setDataModalBultos(null);
  };

  const callbackModalBultos = (dataBulto) => {
    setDataModalBultos(dataBulto);
  };

  useEffect(() => {
    if (dataModalBultos) {
      setModalBultos(true);
    }
  }, [dataModalBultos]);

  const resetModalBultos = () => {
    setModalBultos(false);
    setDataModalBultos(null);
  };

  const listadoClientes = (data) => {
    general.listadoClientesV2(data).then((response) => {
      setClientes(response.client);
      setClienteFull(response.client);
      setPagination({
        pagination: response.pagination,
        isLastPage: response.is_last_page,
        lastPage: response.last_page,
      });
      //setPending(false);
      //setPreloader(false);
    });
  }

  const nextPage = () => {
    if (!pagination.isLastPage) {
      listadoClientes({
        pagination: pagination.pagination + 1,
        ...filtros,
      });
    }
  }

  const prevPage = () => {
    if (pagination.pagination > 1) {
      listadoClientes({
          pagination: pagination.pagination - 1,
          ...filtros,
        });
    }
  }

  const lastPage = () => {
    listadoClientes({
      pagination: pagination.lastPage,
      ...filtros,
    });
  }

  const firstPage = () => {
    listadoClientes({
      pagination: 1,
      ...filtros,
    });
  }


  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col lg={6}>
            <Card>
              <Row>
                <Col>
                  <div className="grupo-input">
                    <small>Tipo de salida</small>
                    <select
                      onChange={masterList}
                      className={`form-control input-border ${
                        errors.type_id && "is-invalid"
                      }`}
                      name="type_id"
                      ref={register({
                        required: true,
                        validate: (value) => value !== "null",
                      })}
                    >
                      <option value="null">Seleccionar..</option>
                      {tipos.map((tipos) => {
                        return (
                          <option key={tipos.id} value={tipos.id}>
                            {tipos.description}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="grupo-input">
                    <small>Guia Master</small>
                    <select
                      className={`form-control input-border ${
                        errors.master_id && "is-invalid"
                      }`}
                      name="master_id"
                      ref={register({
                        required: true,
                        validate: (value) => value !== "null",
                      })}
                      disabled={master.length ? false : true}
                    >
                      <option value="null">Seleccionar..</option>
                      {master.map((master) => {
                        return (
                          <option key={master.id} value={master.id}>
                            {`${pad(5, master.id, "0")} - ${moment(
                              master.date_aperture
                            ).format(
                              "DD/MM/YYYY"
                            )} - ${master.description.toUpperCase()}`}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="grupo-input">
                    <small>Cliente</small>
                    <div className="d-flex flex-column">
                      <div className="d-flex mb-2">
                        <input
                          type="text"
                          className={`form-control input-border ${
                            errors.cliente_name && "is-invalid"
                          }`}
                          name="cliente_name"
                          ref={register({ required: true })}
                          disabled
                          value={
                            clienteSeleccionado !== null
                              ? `${clienteSeleccionado.rut} - ${clienteSeleccionado.name}`
                              : ""
                          }
                        />
                        <button
                          onClick={() => setModalShow(true)}
                          type="button"
                          className="btnx btnx-warn icon-table"
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                      <div className="d-flex">
                        <input
                          type="text"
                          className={`form-control input-border ${
                            errors.cliente_email && "is-invalid"
                          } mr-1`}
                          name="cliente_email"
                          ref={register({ required: true })}
                          disabled
                          value={
                            clienteSeleccionado !== null
                              ? `${clienteSeleccionado.email}`
                              : ""
                          }
                        />
                        <input
                          type="text"
                          className={`form-control input-border ${
                            errors.cliente_telefono && "is-invalid"
                          }`}
                          name="cliente_telefono"
                          ref={register({ required: true })}
                          disabled
                          value={
                            clienteSeleccionado !== null
                              ? `${clienteSeleccionado.phone}`
                              : ""
                          }
                        />
                        <input
                          type="hidden"
                          name="cliente_id"
                          value={
                            clienteSeleccionado !== null
                              ? clienteSeleccionado.id
                              : "null"
                          }
                          ref={register({
                            validate: (value) => value !== "null",
                          })}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col lg={6}>
            <Card>
              <Row>
                <Col>
                  {clienteSeleccionado ? (
                    <div>
                      <DestinatariosModal
                        clienteId={clienteSeleccionado.id}
                        onSelect={destinatarioSelected}
                      />
                      <button
                        onClick={cleardestinatario}
                        type="button"
                        className="btnx btnx-warn mr-1"
                      >
                        Limpiar
                      </button>
                    </div>
                  ) : null}
                  <div className="grupo-input">
                    <small>Nombre completo (Destinatario)</small>
                    <div className="d-flex flex-column">
                      <div className="d-flex mb-1">
                        <input
                          type="text"
                          className={`form-control input-border ${
                            errors.cliente_nombre_receptor && "is-invalid"
                          }`}
                          name="cliente_nombre_receptor"
                          ref={register({ required: true })}
                        />
                      </div>
                      <div className="grupo-input">
                        <small>Identificación</small>
                        <input
                          type="text"
                          className={`form-control input-border ${
                            errors.cliente_identificacion_receptor &&
                            "is-invalid"
                          }`}
                          name="cliente_identificacion_receptor"
                          ref={register({ required: true })}
                        />
                      </div>
                      <div className="grupo-input">
                        <small>Telefono</small>
                        <input
                          type="text"
                          className={`form-control input-border ${
                            errors.cliente_telefono_receptor && "is-invalid"
                          }`}
                          name="cliente_telefono_receptor"
                          ref={register({ required: true })}
                        />
                      </div>
                      <div className="grupo-input">
                        <small>Alguna observación ?</small>
                        <input
                          type="text"
                          className={`form-control input-border ${
                            errors.observacion_guia && "is-invalid"
                          }`}
                          name="observacion_guia"
                          ref={register({ required: true })}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg={12}>
            <Card>
              {clienteSeleccionado ? (
                <Row>
                  <Col>
                    <DireccionesModal
                      clienteId={clienteSeleccionado.id}
                      onSelect={direccionSelecionada}
                      paises={paisesp}
                      estados={estadosp}
                    />
                    <button
                      onClick={limpiardireccion}
                      type="button"
                      className="btnx btnx-warn mr-1"
                    >
                      Limpiar
                    </button>
                  </Col>
                </Row>
              ) : null}
              <Row>
                <Col lg={6}>
                  <div className="grupo-input">
                    <small>Dirección de entrega</small>
                    <input
                      type="text"
                      className={`form-control input-border ${
                        errors.cliente_direccion_entrega && "is-invalid"
                      }`}
                      name="cliente_direccion_entrega"
                      ref={register({ required: true })}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="grupo-input">
                    <small>País</small>
                    <select
                      onChange={selectPais}
                      className={`form-control input-border ${
                        errors.pais && "is-invalid"
                      }`}
                      name="pais"
                      ref={register({
                        required: true,
                        validate: (value) => value !== "null",
                      })}
                    >
                      <option value="null">Seleccione...</option>
                      {paisesp.map((item, index) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.country}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </Col>
                <Col>
                  {multiselect ? (
                    <div className="grupo-input">
                      <small>Estado</small>
                      <select
                        onChange={selectedEstado}
                        className={`form-control input-border ${
                          errors.estado && "is-invalid"
                        }`}
                        name="estado"
                        ref={register({
                          required: true,
                          validate: (value) => value !== "null",
                        })}
                      >
                        <option value="null">Seleccione...</option>
                        {estadosp.map((estado) => {
                          return (
                            <option key={estado.id} value={estado.id_estado}>
                              {estado.estado}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  ) : null}
                </Col>
                <Col>
                  {multiselect ? (
                    <div className="grupo-input">
                      <small>Ciudad</small>
                      <select
                        className={`form-control input-border ${
                          errors.ciudad && "is-invalid"
                        }`}
                        name="ciudad"
                        ref={register({
                          required: true,
                          validate: (value) => value !== "null",
                        })}
                      >
                        <option value="null">Seleccione...</option>
                        {ciudadp.map((ciudad) => {
                          return (
                            <option key={ciudad.id} value={ciudad.id_ciudad}>
                              {ciudad.ciudad}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  ) : null}
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg={12}>
            <Card>
              <Row>
                <Col>
                  <div className="grupo-input">
                    <small>Descripción breve de la carga</small>
                    <input
                      type="text"
                      className={`form-control input-border ${
                        errors.descripcion_carga && "is-invalid"
                      }`}
                      name="descripcion_carga"
                      ref={register({ required: true })}
                    />
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg={12}>
            <Card>
              <Row>
                <Col lg={2}>
                  <button
                    onClick={() => setDetalles(!detalles)}
                    type="button"
                    className="btnx btnx-warn mr-2"
                  >
                    {detalles ? "Desactivar detalle" : "Activar detalle"}
                  </button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="grupo-input">
                    <small>Cantidad</small>
                    <input
                      type="text"
                      className={`form-control input-border`}
                      name="cantidad"
                      onChange={setValuesProductos}
                      disabled={detalles ? false : true}
                      value={productosWait.cantidad}
                    />
                  </div>
                </Col>
                <Col lg={10}>
                  <div className="grupo-input">
                    <small>Descripción</small>
                    <div className="d-flex">
                      <input
                        type="text"
                        className={`form-control input-border`}
                        name="descripcion_productos"
                        onChange={setValuesProductos}
                        disabled={detalles ? false : true}
                        value={productosWait.descripcion_productos}
                      />
                      <button
                        onClick={agregarProductos}
                        type="button"
                        className="btnx btnx-warn icon-table"
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg={12}>
            <Card>
              <Row>
                <Col>
                  {detalles ? (
                    <DataTable
                      title="Detalle productos"
                      customStyles={tablePaquetes.customStyles}
                      columns={tablePaquetes.colummnsWithFunc(removeProducto)}
                      data={productos}
                      dense={true}
                      pagination={true}
                      paginationPerPage={5}
                    />
                  ) : (
                    <h4>No aplica detalle de productos</h4>
                  )}
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg={12}>
            <Card>
              <Row>
                <Col>
                  Las medidas deben ser en Centimetros y usar para el separador
                  punto (.)
                </Col>
              </Row>
              <Row>
                <Col lg={2}>
                  <div className="grupo-input">
                    <small>Alto (cm)</small>
                    <input
                      type="text"
                      className={`form-control input-border`}
                      name="alto"
                      onChange={setValuesBultos}
                      value={bultosDatos.alto}
                    />
                  </div>
                </Col>
                <Col lg={2}>
                  <div className="grupo-input">
                    <small>Ancho (cm)</small>
                    <input
                      type="text"
                      className={`form-control input-border`}
                      name="ancho"
                      onChange={setValuesBultos}
                      value={bultosDatos.ancho}
                    />
                  </div>
                </Col>
                <Col lg={2}>
                  <div className="grupo-input">
                    <small>Largo (cm)</small>
                    <input
                      type="text"
                      className={`form-control input-border`}
                      name="largo"
                      onChange={setValuesBultos}
                      value={bultosDatos.largo}
                    />
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="grupo-input">
                    <small>Peso (Kg)</small>
                    <div className="d-flex">
                      <input
                        type="text"
                        className={`form-control input-border`}
                        name="peso"
                        onChange={setValuesBultos}
                        value={bultosDatos.peso}
                      />
                      {!editBultos ? (
                        <button
                          onClick={agregarBultos}
                          type="button"
                          className="btnx btnx-warn icon-table"
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </button>
                      ) : (
                        <>
                          <button
                            onClick={confirmareditBultos}
                            type="button"
                            className="btnx btnx-warn icon-table"
                          >
                            <FontAwesomeIcon icon={faCheck} />
                          </button>
                          <button
                            onClick={calcelareditBultos}
                            type="button"
                            className="btnx btnx-warn icon-table"
                          >
                            Cancelar
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </Col>
                <Col className="bultosText">Bultos {bultos.length}</Col>
              </Row>
              <Row>
                <Col className="mt-2">
                  <DataTable
                    noHeader={true}
                    customStyles={tablePaquetes.customStyles}
                    columns={tablePaquetes.colummnsBultos(
                      removeBultos,
                      editarBultos,
                      callbackModalBultos,
                      utils.obtenerValorPermiso(
                        "UNIT_BOX_GUIDE",
                        config.operaciones
                      )
                    )}
                    data={bultos}
                    dense={true}
                    pagination={true}
                    paginationPerPage={5}
                    noDataComponent="No se han cargado bultos a esta guia"
                  />
                </Col>
                <BultosModalGuia
                  show={modalBultos}
                  onCancel={resetModalBultos}
                  onConfirm={callbackBultos}
                  currentValue={dataModalBultos}
                />
              </Row>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg={12}>
            <Card>
              <Row>
                <Col className="botonGenerar" lg={3}>
                  <button type="submit" className="btnx btnx-warn icon-table">
                    Completar generación de guia
                  </button>
                  {/*
              <ConfirmAlertV2
                onConfirm={confirmModoEspera}
                message="Confirme que desea generar la guia en modo de espera, para completar en otro momento."
                buttonText="Generar guia en modo reserva"
            />*/}

                  <input
                    value="null"
                    type="hidden"
                    name="recipient_id"
                    ref={register()}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Modal show={modalShow}>
          <Card>
            <div>
              <input
                  type="text"
                  className={`form-control input-border`}
                  name="client_finder"
                  placeholder="Buscar por nombre del cliente"
                  onChange={(ev) => setFindText(ev.target.value)}
                  value={findText}
                />
            </div>
            <DataTableExtensions
              columns={tablePaquetes.colummnsWithClientes(
                seleccionarClienteModal
              )}
              filter={false}
              data={clientes}
              export={false}
              print={false}
            >
              <DataTable
                noHeader={true}
                customStyles={tablePaquetes.customStyles}
                dense={true}
              />
            </DataTableExtensions>
            <Row>
            <Col className="d-flex justify-content-end">
              <Pagination>
                <Pagination.First
                   onClick={firstPage}
                   disabled={pagination.pagination === 1 ? true : false}
                />
                <Pagination.Prev
                   onClick={prevPage}
                   disabled={pagination.pagination === 1 ? true : false}
                />
                <Pagination.Next 
                  onClick={nextPage}
                  disabled={pagination.isLastPage}
                />
                <Pagination.Last
                  onClick={lastPage}
                  disabled={pagination.isLastPage}
                />
              </Pagination>
           </Col>
          </Row>
            <div>
              <button
                onClick={() => setModalShow(false)}
                type="button"
                className="btnx btnx-warn"
              >
                Cerrar
              </button>{" "}
              <button
                onClick={() => history.replace("/clientes")}
                type="button"
                className="btnx btnx-warn"
              >
                Nuevo cliente
              </button>
            </div>
          </Card>
        </Modal>

        <Modal show={modalPago} size={"xl"}>
          <Row className="mt-3">
            <Col lg={12}>
              <Card>
                <FacturacionComponent
                  btnClose={true}
                  onClose={() => modalPagoInit(true)}
                  dataClient={clienteSeleccionado}
                  isGuide={true}
                  dataFullGuide={guideFullInformation}
                />
              </Card>
            </Col>
          </Row>
        </Modal>
      </form>
    </>
  );
};

export default Paquetes;
